<!-- 销售汇总 -->
<template>
  <div class="sales-summary">
    <div class="search">
      <span class="date-quantum" @click="show = true">
        {{selectedTime}}
        <cc-svg-icon :class-name="show ? 'icon-up':'icon-down'" icon-class="left-arrow" />
      </span>
    </div>
    <ul class="sales-summary-tabs" v-if="data">
      <li
        @click="changeTab('order_cate_price_list')"
        :class="{'active':selectedType === 'order_cate_price_list'}">
        <p>订单数量</p>
        <span>{{data.order_cate_price_list.summary}}</span>
      </li>
      <li
        @click="changeTab('order_feedback_money_sum_list')"
        :class="{'active':selectedType === 'order_feedback_money_sum_list'}">
        <p>销售数量</p>
        <span>{{data.order_feedback_money_sum_list.summary}}</span>
      </li>
      <li
        @click="changeTab('order_quantity_list')"
        :class="{'active':selectedType === 'order_quantity_list'}">
        <p>销售金额</p>
        <span>￥{{data.order_quantity_list.summary}}</span>
      </li>
      <li
        @click="changeTab('order_sum_goods_list')"
        :class="{'active':selectedType === 'order_sum_goods_list'}">
        <p>提成</p>
        <span>￥{{data.order_sum_goods_list.summary}}</span>
      </li>
    </ul>
    <div class="order-count">
      <p class="order-count-title">订单数量</p>
      <div ref="lineChart" style="height:200px;width:100%"></div>
    </div>
    <div class="sales-class">
      <p class="sales-class-title">订单数量</p>
      <div ref="pieChart" style="height:200px;width:100%"></div>
    </div>
    <date-popup :show.sync="show" @loadData="loadData"/>
  </div>
</template>

<script>
import DatePopup from '../components/date-popup'
import { loadSaleCount } from '@/fetch/distributor'
import echarts from '@/lib/echarts'
import { ResultCode } from '~const/ResultCode'
export default {
  components: {
    DatePopup
  },

  props: {},

  data () {
    return {
      show: false,
      selectedTime: '',
      selectedType: 'order_cate_price_list',
      form: {
        start_time: '',
        end_time: '',
        time_type: 5 // 兼容pc端
      },
      data: null
    }
  },

  computed: {},

  watch: {},

  created () {
  },
  mounted () {
    this.initPieEcharts()
  },

  methods: {
    changeTab (type = 'order_cate_price_list') {
      this.selectedType = type
      this.initLineEcharts(this.data[type].detail)
    },
    getLastDay (year, month) {
      var newYear = year // 取当前的年份
      var newMonth = month++// 取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        newMonth -= 12 // 月份减
        newYear++ // 年份增
      }
      var newDate = new Date(newYear, newMonth, 1) // 取当年当月中的第一天
      return (new Date(newDate.getTime() - 1000 * 60 * 60 * 24)).getDate()// 获取当月最后一天日期
    },
    async loadData (msg) {
      this.selectedTime = msg
      let reg = /\d*/g
      let dateArr = this.selectedTime.match(reg).filter(Boolean)
      let lastDay = this.getLastDay(dateArr[0], dateArr[1])
      let [startTime, endTime] = [`${dateArr[0]}-${dateArr[1]}-01`, `${dateArr[0]}-${dateArr[1]}-${lastDay}`]
      let { status, data } = await loadSaleCount({
        start_time: startTime,
        end_time: endTime,
        time_type: 5 // 兼容pc端
      })
      if (status === ResultCode.SUCCESS) {
        this.data = data
        this.changeTab()
      }
    },
    initLineEcharts (data) {
      const option = {
        xAxis: {
          type: 'category',
          data: Object.keys(data),
          axisLine: {
            lineStyle: {
              color: '#DCDCDC' // x轴颜色
            }
          },
          axisTick: { // 坐标轴刻度相关设置。
            // show: false
          },
          axisLabel: { // 坐标轴刻度标签的相关设置
            textStyle: {
              color: '#333333' // x轴文字颜色
            }
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: 10,
          right: 10,
          top: 20,
          bottom: '0%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisTick: { // 坐标轴刻度相关设置。
            show: false
          },
          splitLine: { // 坐标轴在 grid 区域中的分隔线。
            lineStyle: {
              color: '#EEEEEE'// y轴颜色
            }
          },
          axisLabel: { // 坐标轴刻度标签的相关设置
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [{
          itemStyle: {
            normal: {
              color: '#1BB0D9'
            }
          },
          lineStyle: {
            width: 1
          },
          data: Object.values(data),
          type: 'line',
          symbol: 'none'
        }]
      }
      const myChart = echarts.init(this.$refs.lineChart)
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    },
    initPieEcharts () {
      const data = [
        { value: 335, name: '中医中药', price: 40 },
        { value: 310, name: '西医西药', price: 40 },
        { value: 234, name: '医疗器械', price: 40 },
        { value: 135, name: '妇科用药', price: 40 },
        { value: 1548, name: '母婴产品', price: 40 },
        { value: 1548, name: '其他', price: 40 }
      ]
      const option = {
        grid: {

        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['50%', '53%'],
            color: ['#3AA0FF', '#36CBCB', '#FAD337', '#975FE4', '#F2637B', '#4DCB73'],
            avoidLabelOverlap: false,
            data: data,
            itemStyle: { // 此配置
              normal: {
                borderWidth: 2,
                borderColor: '#ffffff'
              },
              emphasis: {
                borderWidth: 0,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      let myChart = echarts.init(this.$refs.pieChart)
      myChart.setOption(option)
    }
  }
}

</script>
<style lang='scss' scoped>
.sales-summary{
  .search{
    display:flex;
    justify-content: center;
    height: 40px;
    align-items: center;
    .date-quantum{
      border: 1px solid #DCDCDC;
      border-radius: 10px;
      color: #333333;
      background: #ffffff;
      padding: 3px 5px;
    }
    .icon-down{
      transform: rotate(-90deg) translate(2px,2px);
      color: #333333;
    }
    .icon-up{
      transform: rotate(90deg) translate(-2px,-2px);
      color: #333333;
    }
  }
  &-tabs{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .active{
      color: var(--APP_theme_color);
      font-weight:bolder;
      background: var(--APP_theme_color);
      display: flex;
      position: relative;
      z-index: 10;
      &::after {
        content: "";
        display: inline-block;
        width: 100%;
        height: 100%;
        background: white;
        opacity: 0.9;
        position: absolute;
        z-index: 5;
        left: 0;
        top: 0;
      }
      p,span{
        position: relative;
        z-index: 10;
      }
    }
    li{
      position: relative;
      width: 49.5%;
      height: 57px;
      background: #ffffff;
      margin-bottom: 1px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      color: #999999;
      font-size: 15px;
    }
  }
  .order-count{
    background: #ffffff;
    margin: 10px 10px 0;
    padding: 15px 9px;
    &-title{
      font-size: 14px;
      color: #333333;
    }
  }
  .sales-class{
    background: #ffffff;
    margin: 2px 10px 0;
    padding: 15px 9px;
    &-title{
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>
